import {
	EngineCommunicationChannels,
	LoggerAction,
	StorageUploadFileChannel,
} from '@webitel/api-services/gen/models';
import { RingtoneType } from '@webitel/ui-sdk/enums';
import { NotificationType } from '../../../modules/settings/modules/notifications/enums/NotificationType';

export default {
	auth: {
		register: 'Rejestracja',
		login: 'Logowanie',
		registerReset: 'Resetuj hasło',
		detailsSubtitle: 'Wprowadź swoje szczegóły poniżej',
		resetPasswordLink: 'Zapomniałeś hasła?',
		user: 'Nazwa użytkownika',
		password: 'Hasło',
		confirmPassword: 'Powtórz hasło',
		key: 'Klucz licencji',
		registerSubmit: 'Zarejestruj',
		resetSubmit: 'Resetuj',
		loginSubmit: 'Zaloguj',
		carousel: {
			title1: 'Chmura vs. Lokalnie',
			text1:
				'Polityka bezpieczeństwa nie zezwala na przechowywanie danych i używanie usług w chmurze? Z Webitel, możesz zbudować centrum kontaktowe na swoim miejscu!',

			title2: 'Wielokanałowe VS Pełne-Kanałowe',
			text2:
				'Zawsze i wszędzie w kontakcie z klientami! Menu IVR dowolnej złożoności, kampanie wychodzące, interakcje wchodzące lub wiadomości w sieciach społecznościowych - teraz jest prostsze niż kiedykolwiek!',

			title3: 'Infrastruktura odporna na awarie',
			text3:
				'Więcej nieplanowanych przestojów. Szybka skalowalność i architektura odporna na awarie umożliwiają jednoczesne obsługę ponad 1000 połączeń klientów na minutę z różnych kanałów komunikacyjnych.',

			title4: 'Projekt',
			text4:
				'Nowy minimalistyczny interfejs z najbardziej użytecznym panelem administracyjnym, który pozwala na szybkie dostępy do wszystkich niezbędnych funkcji. Mniej kliknięć - więcej funkcji.',

			title5: 'Nowy moduł pracy grupy agentów',
			text5:
				'Najbardziej efektywne dystrybucja połączeń. Agent może mieć wiele umiejętności jednocześnie, aby uczestniczyć w różnych kampaniach. Klient jest obsługiwany tylko przez profesjonalistów.',

			title6: 'Ustawienia uprawnień',
			text6:
				'Nowy moduł zarządzania uprawnieniami - nowe możliwości kontroli. Użytkownicy mogą wprowadzać zmiany tylko w sekcjach, a także w akcjach.',
		},
	},

	header: {
		logout: 'Wyloguj',
		docs: 'Dokumentacja',
	},

	appNavigator: {
		title: 'Aplikacje Webitel',
		admin: 'Administrator',
		agent: 'Przestrzeń robocza Agent',
		supervisor: 'Przestrzeń robocza Nadzorcy',
		audit: 'Audyt',
		history: 'Historia połączeń',
		grafana: 'Grafana',
	},

	settings: {
		settings: 'Ustawienia | Ustawienia',
		changePassword: 'Zmień hasło',
		language: 'Język',
		fallbackLanguage: 'Język domyślny',
		webPhone: 'WebPhone',
		useWebPhone: 'Użyj WebPhone',
		useStun: 'Użyj STUN',
		notifications: {
			[NotificationType.NewMessageSound]: 'Dźwięk nowej wiadomości',
			[NotificationType.NewChatSound]: 'Dźwięk nowego czatu',
			[NotificationType.SelfAssignedCallSound]:
				'Dźwięk samodzielnie przypisanego połączenia',
			[NotificationType.ChatEndSound]: 'Dźwięk końca czatu',
			[NotificationType.CallEndSound]: 'Dźwięk końca połączenia',
			[NotificationType.TaskEndSound]: 'Dźwięk końca zadania',
			[NotificationType.ChatEndPush]: 'Powiadomienie push o zakończeniu czatu',
			[NotificationType.CallEndPush]:
				'Powiadomienie push o zakończeniu połączenia',
			[NotificationType.TaskEndPush]:
				'Powiadomienie push o zakończeniu zadania',
			[NotificationType.SocketCloseSound]: 'Dźwięk utraty połączenia',
		},
		ringtones: {
			title: 'Zmień dzwonek połączenia',
			ringtone: 'Dzwonek',
			customRingtone: 'Użyj niestandardowego dźwięku',
		},
		ringtoneVolume: {
			title: 'Ustawienia głośności',
			[RingtoneType.Call]: 'Połączenie',
			[RingtoneType.Chat]: 'Czat',
			[RingtoneType.Task]: 'Zadanie',
		},
		security: {
			security: 'Bezpieczeństwo',
			logoutTitle: 'Wyloguj tego użytkownika z innych urządzeń',
		},
	},

	validation: {
		email: 'Powinien wyglądać jak email',
		required: 'To pole jest wymagane',
		sameAs: 'Nieprawidłowe hasło',
		gatewayHostValidator: 'Powinien wyglądać jak IPv4 lub FQDN',
		ipValidator: 'Powinien wyglądać jak IPv4',
		macValidator: 'Powinien wyglądać jak MAC',
		numeric: 'Powinna być liczba',
		requiredArrayValue: 'Tablica nie może być pusta',
		isPositiveValue: 'Wartość powinna być liczbą dodatnią',
		cron: 'Nieprawidłowe wyrażenie cron',
		hourRange: 'Godziny muszą być od 00 do 23',
		timerangeStartLessThanEnd: 'Czas "Od" nie może być późniejszy niż "Do"',
		timerangeNotIntersect:
			'Interwały czasowe w tym samym dniu nie mogą się nakładać',
	},

	nav: {
		directory: {
			directory: 'Katalog',
		},
		routing: {
			routing: 'Routing',
		},
		lookups: {
			lookups: 'Wyszukiwanie',
		},
		ccenter: {
			ccenter: 'Centrum kontaktowe',
		},
		integrations: {
			integrations: 'Integracje',
		},
		permissions: {
			permissions: 'Uprawnienia',
		},
		system: {
			system: 'System',
		},
	},

	home: {
		dashboard: 'Pulpit',
		welcomeText: '',
		news: 'Aktualności',
	},

	objects: {
		all: 'Wszystkie {entity}',
		administration: 'Administracja',
		general: 'Ogólne',
		new: 'Nowy',
		add: 'Dodaj',
		create: 'Utwórz',
		read: 'Czytaj',
		edit: 'Edytuj',
		delete: 'Usuń',
		save: 'Zapisz',
		saved: 'Zapisano',
		saveAs: 'Zapisz jako',
		close: 'Zamknij',
		next: 'Następny',
		back: 'Wstecz',
		change: 'Zmień',
		name: 'Nazwa',
		title: 'Tytuł',
		description: 'Opis',
		action: 'Akcja',
		allow: 'Zezwól',
		password: 'Hasło',
		history: 'Historia',
		copy: 'Kopiuj',
		copied: 'Skopiowano do schowka!',
		createdAt: 'Utworzono',
		createdBy: 'Utworzone przez',
		online: 'Online',
		offline: 'Offline',
		on: 'Włączony',
		off: 'Wyłączony',
		ok: 'Ok',
		enabled: 'Włączony',
		status: 'Status',
		from: 'Od',
		to: 'Do',
		importJSON: 'Importuj JSON',
		addNew: 'Dodaj nowy',
		provider: 'Dostawca',
		default: 'Domyślny',
		service: 'Usługa',
		tts: 'Tekst na mowę',
		stt: 'Mowa na tekst',
		key: 'Klucz',
		ID: 'ID',
		email: ({ linked }) => linked('vocabulary.emails'),
		updatedAt: 'Zmodyfikowano',
		emptyWorkspace: 'Jeszcze nie ma rekordów',
		emptyResultSearch: 'Twoje wyszukiwanie nie dało wyników',

		deleteConfirmation: {
			title: 'Potwierdzenie usunięcia',
			askingAlert:
				'Czy na pewno chcesz usunąć {count} element? | Czy na pewno chcesz usunąć {count} elementów?',
			undoneActionAlert: 'Ta akcja nie może być cofnięta.',
			deleteAll: 'WSZYSTKIE',
		},
		generalInfo: 'Informacje ogólne',
		objectHeader: {},
		directory: {
			directory: 'Katalog',
			passwordInfo:
				'Wprowadź wartość tylko wtedy, gdy chcesz ją edytować (lub utworzyć nową). Puste pole pozostawi wartość bez zmian',
			users: {
				users: 'Użytkownik | Użytkownicy',
				allUsers: 'Wszystkie użytkownicy',
				searchPlaceholder: 'Nazwa, login, rozszerzenia, status',
				login: 'Login',
				extensions: 'Rozszerzenia',
				state: 'Stan',
				DnD: 'DnD',
				status: 'Status',
				roles: 'Role',
				tokens: 'Tokeny',
				usage: 'Użycie',
				expiryDays: 'Dni ważności',
				expiryDate: 'Data wygaśnięcia',
				roleAdmin: 'Administrator',
				license: 'Licencja',
				devices: 'Urządzenia',
				defaultDevice: 'Domyślne urządzenie (z listy wybranych urządzeń)',
				deviceNotFound: 'Nie znaleziono urządzenia?',
				createNewDevice: 'Dodaj nowe',
				variables: 'Zmienne',
				varKey: 'Klucz',
				varVal: 'Wartość',
				token: 'Token | Tokeny',
				tokenPopupHeader: 'Twój klucz tokenu został pomyślnie utworzony!',
				tokenPopupText:
					'Pobierz teraz plik klucza lub skopiuj go. Jeśli nie pobierzesz pliku klucza teraz, nie będziesz mógł go ponownie odzyskać. Aby zapewnić bezpieczeństwo, przechowuj swój klucz tokenowy w bezpieczny sposób i nie go udostępniaj.',
				tokenPopupCopy: 'Skopiuj do schowka',
				tokenPopupSave: 'Zapisz jako TXT',
				userIp: 'IP użytkownika',
				userId: 'ID użytkownika',
				download: 'Pobierz',
				regenerate: 'Regeneruj',
				askingAlert:
					'Czy na pewno chcesz zregenerować kod? Użytkownik nie będzie mógł się zalogować',
				chatName: 'Nazwa wyświetlana w czacie',
				temporaryPassword: 'Hasło tymczasowe',
				communications: 'Komunikacja',
				generateDevice: 'Wygeneruj urządzenie',
				deviceGenerationTitle: 'Generowanie urządzenia',
				deviceGeneration:
					'Ta akcja automatycznie utworzy nowe urządzenie dla tego użytkownika.',
				deviceWasGenerated: 'Urządzenie zostało wygenerowane',
				deviceGenerationConfirmTitle: 'Potwierdź generowanie urządzenia',
				generateDeviceConfirmation:
					'Bieżące urządzenia zostaną zastąpione wygenerowanym. Kontynuować?',
				authorizationSecurity: 'Autoryzacja i bezpieczeństwo',
				mustChangePassword:
					'Użytkownik musi zmienić hasło przy pierwszym logowaniu.',
				extensionsHelperText: 'Numer wewnętrzny musi zawierać tylko cyfry',
				csvMappingFields: {
					login: ({ linked }) => linked('vocabulary.login'),
					name: 'Imię',
					extension: ({ linked }) =>
						linked('objects.directory.users.extensions'),
					email: ({ linked }) => linked('vocabulary.emails'),
				},
				logout: {
					endAllSessions: 'Zakończ wszystkie sesje',
					endAllMySessions: 'Zakończ wszystkie moje sesje',
					endSessionConfirmation: 'Potwierdzenie zakończenia sesji',
					endSessionConfirmationText:
						'Czy na pewno chcesz zakończyć wszystkie sesje?',
					endMultipleSessionsConfirmationText:
						'Czy na pewno chcesz zakończyć wszystkie sesje dla {count} użytkowników?',
					tooltip: 'Użytkownik zostanie wylogowany ze wszystkich urządzeń',
				},
			},
			license: {
				customers: 'Klienci',
				license: 'Licencja | Licencje',
				licenseId: 'ID',
				allCustomers: 'Wszystkie klienci',
				allLicenses: 'Wszystkie licencje',
				serial: 'Seryjny',
				product: 'Produkt',
				validFrom: 'Ważny od',
				validTill: 'Ważny do',
				used: 'Używany',
				limit: 'Limit',
				status: 'Status',
				competitive: 'Konkurencyjny',
				searchPlaceholder: 'Seryjny, produkt',
				domain: 'Domena',
				daysToExpire: {
					0: 'Wygasł',
					30: '30 lub mniej',
					90: '90 lub mniej',
					days: ' dni',
				},
				importLicense: 'Importuj licencję',
				licenseKey: 'Klucz licencji',
			},
			devices: {
				devices: 'Urządzenie | Urządzenia',
				newDevice: 'Nowe urządzenie',
				newDeviceDescription: 'Opis nowego urządzenia',
				allDevices: 'Wszystkie urządzenia',
				searchPlaceholder: 'Nazwa, użytkownik, ID autoryzacji & ID biurka',
				authId: 'ID autoryzacji',
				presence: 'Obecność',
				hotdesk: 'Biurko gorące',
				hotdeskDevice: 'Urządzenie biurka gorącego',
				hotdeskDeviceSettings: 'Ustawienia urządzenia biurka gorącego',
				hotdeskIncorrectInput: 'Nieprawidłowa nazwa hosta',
				hotdeskInputHint:
					'Aby ułatwić identyfikację tego urządzenia, powinieneś go pokryć przyjaznymi aliasami biurka gorącego. Prawidłowa nazwa musi zawierać następujące znaki: A-Z, a-z, 0-9, -, _',
				deviceSettings: 'Ustawienia urządzenia',
				hostName: 'Nazwa hosta',
				phoneInfo: 'Informacje o telefonie',
				phone: 'Telefon',
				vendor: 'Producent',
				model: 'Model',
				ipv4: 'IPv4',
				mac: 'MAC',
				deviceHistory: 'Historia urządzenia',
				loggedIn: 'Zalogowany',
				loggedOut: 'Wylogowany',
				state: {
					nonreg: 'Niezarejestrowany',
					reged: 'Zarejestrowany',
					ringing: 'Dzwoniący',
					dialing: 'Dialing',
					dialog: 'Dialog',
					onhold: 'Na hol',
				},
				passwordSetFromAccount:
					'Jeśli nie ustawisz hasła, będzie ono takie samo jak konto',
				csvMappingFields: {
					account: ({ linked }) => linked('webitelUI.headerActions.account'),
					name: ({ linked }) => linked('reusable.name'),
					password: ({ linked }) => linked('vocabulary.password'),
					vendor: 'Producent',
					model: 'Model',
					mac: 'Adres MAC',
					ip: 'Adres IP',
				},
			},
		},
		permissions: {
			permissions: 'Uprawnienia',
			permissionsRole: 'Rola | Role',
			allRoles: 'Wszystkie role',
			searchPlaceholder: 'rola ..',
			roles: {
				permissions: {
					permissions: 'Uprawnienie roli | Uprawnienia roli',
					add: 'Dodaj',
					delete: 'Usuń',
					read: 'Wybierz',
					write: 'Aktualizuj',
					eavesdropCall: 'Słuchaj połączenia',
					playbackRecordFile: 'Odtwórz plik nagrywania',
					timeLimitedRecordFile: 'Odtwórz plik nagrywania ograniczony w czasie',
					resetActiveAttempts: 'Zresetuj aktywne próby',
					limitWorkspaceContacts: 'Ogranicz kontakty w Workspace',
					exportDataGrid: 'Eksportuj siatkę danych',
					viewCdrPhoneNumbers: 'Wyświetl numery CDR',
					manageUserRoles: 'Zarządzaj rolami użytkowników',
					manageUserLicense: 'Zarządzaj licencjami użytkowników',
					changeUserPassword: 'Zmień hasło użytkownika',
					systemSetting: 'Zarządzaj ustawieniami systemowymi',
					addDescription: 'Uprawnienie do tworzenia dowolnych obiektów',
					deleteDescription: 'Uprawnienie do usuwania dowolnych obiektów',
					readDescription: 'Uprawnienie do wyboru dowolnych obiektów',
					writeDescription: 'Uprawnienie do modyfikowania dowolnych obiektów',
					eavesdropCallDescription:
						'Uprawnienie do słuchania aktywnego rozmowy',
					playbackRecordFileDescription:
						'Uprawnienie do odtwarzania plików nagrywania połączenia',
					timeLimitedRecordFileDescription:
						'Uprawnienie do odtwarzania plików nagrywania ograniczonego w czasie',
					resetActiveAttemptsDescription:
						'Uprawnienie do resetowania aktywnych prób',
					limitWorkspaceContactsDescription:
						'Ograniczenie uprawnienia do wyświetlenia listy kontaktów w Workspace',
					exportDataGridDescription:
						'Uprawnienie do eksportowania siatki danych do pliku',
					viewCdrPhoneNumbersDescription: 'Wyświetl numery CDR',
					manageUserRolesDescription:
						'Uprawnienie do zarządzania zestawem ról użytkowników',
					manageUserLicenseDescription:
						'Uprawnienie do zarządzania zestawem licencji użytkowników',
					changeUserPasswordDescription:
						'Uprawnienie do zmiany hasła użytkowników',
					systemSettingDescription:
						'Uprawnienie do uzyskiwania dostępu i zarządzania sekcją Konfiguracja',
					schemeVariables: 'Zarządzaj zmiennymi globalnymi',
					controlAgentScreen: 'Sterowanie ekranem agenta',
					schemeVariablesDescription:
						'Uprawnienie do uzyskiwania dostępu i zarządzania sekcją Zmienne globalne',
				},
				addPermission: 'Dodaj uprawnienie roli',
				usage: 'Użycie',
				applicationsAccess: {
					applicationsAccess: 'Dostęp do aplikacji | Dostęp do aplikacji',
					access: 'Dostęp',
				},
			},
			object: {
				object: 'Obiekty',
				allObjects: 'Wszystkie obiekty',
				ObAC: 'Zarządzane przez operacje',
				RbAC: 'Zarządzane przez rekordy',
				operations: 'Operacje',
				searchPlaceholder: 'obiekt ..',
				newPermissionRole: 'Nowy uprawniony',
				rbacDefault: 'Domyślne uprawnienie do rekordu',
				grantor: 'Darczyńca',
				grantee: 'Uprawniony',
				create: 'Utwórz',
				delete: 'Usuń',
				accessMode: {
					1: 'Zabronione',
					2: 'Zezwól',
					3: 'Zezwól z delegacją',
				},
			},
		},
		lookups: {
			lookups: 'Wyszukiwanie',
			skills: {
				skills: 'Umiejętność | Umiejętności',
				capacity: 'Pojemność',
				minCapacity: 'Min pojemność',
				minCapacityLessOrEqualToMaxCapacityValidator:
					'Powinna być mniejsza lub równa maksymalnej pojemności',
				maxCapacity: 'Maksymalna pojemność',
				maxCapacityMoreOrEqualToMinCapacityValidator:
					'Powinna być większa lub równa minimalnej pojemności',
				lvl: 'Poziom',
				agentSkills: 'Umiejętność agenta | Umiejętności agentów',
				allSkills: 'Wszystkie umiejętności',
				state: 'Stan',
				stateForAll: 'Stan dla wszystkich',
				changeSkillTo: 'Zmień umiejętność na',
				changeAgentsSkill: 'Zmień umiejętność agenta',
				totalAgents: 'Łączna liczba agentów',
				activeSkillAgents: 'Aktywne umiejętności agentów',
				assignSkillToAgents: 'Przypisz umiejętność agentom',
				assignAgent: 'Przypisz agenta',
				selectCapacityAndState: 'Wybierz pojemność i stan',
			},
			buckets: {
				buckets: 'Kubeł | Kubeły',
				allBuckets: 'Wszystkie kubeły',
				addBucket: 'Dodaj kubeł',
			},
			blacklist: {
				blacklist: 'Lista | Listy',
				allBlacklists: 'Wszystkie listy',
				number: 'Numer | Numery',
				newNumber: 'Nowy numer',
				numbersCount: 'Liczba numerów',
				expireAt: 'Wygasa',
				temporary: 'Tymczasowy',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
					description: ({ linked }) => linked('vocabulary.description'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
				},
				importResult:
					'Zaimportowane numery: {imported}. Pominięte duplikaty: {skipped}.',
			},
			media: {
				mediaFiles: 'Plik multimedialny | Pliki multimedialne',
				allMediaFiles: 'Wszystkie pliki multimedialne',
				createdAt: 'Utworzono',
				format: 'Format',
				size: 'Rozmiar',
				textToSpeech: 'Tekst na mowę',
				popupSettings: 'Ustawienia',
				lang: 'Język',
				voice: 'Głos',
				token: 'Token',
				key: 'Klucz',
				dragPlaceholder: 'Przeciągnij i upuść pliki',
				dragPlaceholderHere: 'tutaj.',
				tts: {
					hint: 'Utwórz plik audio',
					textType: {
						textType: 'Typ tekstu',
						ssml: 'SSML',
					},
				},
			},
			regions: {
				regions: 'Lokalizacja | Lokalizacje',
				allRegions: 'Wszystkie lokalizacje',
			},
			timezone: {
				timezone: 'Strefa czasowa | Strefy czasowe',
			},
			calendars: {
				calendars: 'Kalendarz | Kalendarze',
				allCalendars: 'Wszystkie kalendarze',
				searchPlaceholder: 'Nazwa, opis...',
				timezone: 'Strefa czasowa',
				start: 'Początek',
				end: 'Koniec',
				workWeek: 'Tydzień pracy',
				specialTime: 'Specjalny czas',
				holidays: 'Święto | Święta',
				date: 'Data',
				repeat: 'Powtarzaj',
				fulltime: 'Tymczasowy',
				everyYear: 'Powtarzaj co rok',
				newHoliday: 'Nowe święto',
				mon: 'Poniedziałek',
				tue: 'Wtorek',
				wed: 'Środa',
				thu: 'Czwartek',
				fri: 'Piątek',
				sat: 'Sobota',
				sun: 'Niedziela',
				workingTime: 'Czas pracy',
				workStart: 'Początek czasu pracy',
				workStop: 'Koniec czasu pracy',
			},
			communications: {
				communications: 'Typ komunikacji | Typy komunikacji',
				allCommunications: 'Wszystkie typy komunikacji',
				addCommunication: 'Dodaj komunikację',
				missingCommunication: 'Proszę dodać typ komunikacji',
				code: 'Kod',
				channels: {
					[EngineCommunicationChannels.Phone]: 'Telefon',
					[EngineCommunicationChannels.Email]: 'Email',
					[EngineCommunicationChannels.Messaging]: 'Wiadomości',
				},
			},
			pauseCause: {
				pauseCause: 'Powody pauzy',
				allPauseCause: 'Wszystkie przyczyny zawieszenia agenta',
				limit: 'Limit (min)',
				min: 'min',
				allowAdmin: 'Administrator może zmienić ten status',
				allowSupervisor: 'Nadzorca może zmienić ten status',
				allowAgent: 'Agent może zmienić ten status',
			},
			quickReplies: {
				quickReplies: 'Szybka odpowiedź | Szybkie odpowiedzi',
			},
			activityTypes: {
				activityTypes: 'Typ aktywności | Typy aktywności',
			},
		},
		routing: {
			routing: 'Routing',
			ip: 'IP',
			protocol: 'Protokół',
			port: 'Port',
			configuration: 'Konfiguracja',
			schema: 'Schemat przepływu',
			json: 'JSON',

			flow: {
				flow: 'Schemat przepływu | Schematy przepływów',
				allFlowSchemas: 'Wszystkie schematy przepływów',
				createFlowSelectionPopup: 'Utwórz nowy przepływ',
				createNew: 'Utwórz nowy?',
				editor: 'Edytor',
				diagram: {
					diagram: 'Diagram',
					description:
						'Utwórz nowy przepływ za pomocą narzędzia Webitel Flow Diagram',
				},
				code: {
					code: 'Kod',
					description: 'Utwórz nowy przepływ za pomocą edytora JSON-schematu',
				},
				askingAlert: 'Czy chcesz zapisać zmiany wprowadzone w "{name}" ?',
			},

			dialplan: {
				dialplan: 'Dialplan',
				dialplanRules: 'Reguły dialplanu',
				pattern: 'Numer docelowy',
				dialplanRule: 'Reguła dialplanu',
				position: 'Pozycja',
				allowTransfer: 'Zezwól na przekazanie',
			},

			chatplan: {
				chatplan: 'Chatplan | Chatplany',
				allChatplans: 'Wszystkie chatplany',
			},

			gateways: {
				gateways: 'Brama | Bramy',
				allGateways: 'Wszystkie bramy',
				trunkingGateway: 'Brama trunkingowa',
				registerGateway: 'Brama rejestrująca',
				stateSuccess: 'Sukces',
				stateFailed: 'Niepowodzenie',
				stateProgress: 'W toku',
				stateNonreg: 'Niezarejestrowana',
				proxy: 'Proxy',
				searchPlaceholder: 'wyszukaj bramę...',
				host: 'Host',
				trunkingACL: 'Lista kontroli dostępu trunkingowego',
				hostnameTrunking: 'Hostname serwera/Bramy lub IP',
				hostnameRegister: 'Hostname rejestratora/serwera/Bramy lub IP',
				expire: 'Wygasa',
				authID: 'Nazwa użytkownika',
				account: 'Konto',
				outboundProxy: 'Hostname lub IP hosta wychodzącego',
				newGateway: 'Nowa brama',
				newGatewayDescription: 'Opis nowej bramy',
				SIPregistrations: 'Rejestracja SIP',
				SIPregistrationsDescription: 'Opis rejestracji SIP',
				SIPtrunking: 'Trunking SIP',
				SIPtrunkingDescription: 'Opis trunkingu SIP',
			},
			chatGateways: {
				templates: {
					templates: 'Szablon | Szablony',
					title: 'Nazwa członka w przestrzeni roboczej',
					close: 'Komunikat zakończenia czatu',
					join: 'Komunikat dołączenia agenta',
					left: 'Komunikat odłączenia agenta',
					filePolicyFail: 'Niedozwolony format pliku',
				},
				chatGateways: 'Brama czatu | Bramy czatu',
				allChatGateways: 'Wszystkie bramy czatu',
				telegramBot: {
					telegramBot: 'Bot Telegram',
				},
				telegramApp: {
					telegramApp: 'Aplikacja Telegram',
					signedAs: 'Jesteś podpisany jako',
					joinTelegram: 'Zaloguj się do Telegram',
					signOut: 'Wyloguj się z Telegram',
					metadata: {
						apiId: 'ID API',
						apiHash: 'Hash API',
					},
				},
				infobip: {
					infobip: 'Infobip',
				},
				messenger: {
					meta: 'Meta',
					addOrRemovePages: 'Dodaj lub usuń strony',
					accounts: 'Konta',
					metadata: {
						clientId: 'ID aplikacji',
						clientSecret: 'Sekret aplikacji',
						apiVersion: 'Wersja API',
						apiVersionHint: 'Format: vXX.X (na przykład v24.0)',
					},
					facebook: {
						pages: 'Strony Facebook',
						subscription: 'Subskrypcja webhooka',
					},
					instagram: {
						instagram: 'Instagram',
						comments: 'Śledź komentarze',
						mentions: 'Śledź wzmianki',
					},
					whatsapp: {
						whatsapp: 'Whatsapp',
						token: 'Token',
						status: 'Status',
						number: 'Numer telefonu',
						review: 'Przegląd',
					},
				},
				viber: {
					viber: 'Viber',
					style: {
						style: 'Styl',
						btnBackColor: 'Kolor tła przycisku',
						btnFontColor: 'Kolor czcionki przycisku',
					},
				},
				webchat: {
					webchat: 'Czat internetowy',
					copyCode: 'Skopiuj kod dla strony',
					copyCodeHint:
						'Musisz ponownie wygenerować i wstawić kod Widgetu na stronę po każdej modyfikacji ustawień Widgetu',
					metadata: {
						mediaMaxSize: 'Maksymalny rozmiar mediów (MB)',
					},
					view: {
						view: 'Wyświetl',
						borderRadius: 'Kształt przycisku',
						language: 'Język',
						position: 'Pozycja',
						btnColor: 'Kolor przycisku',
						logoUrl: 'URL logo',
						logoHint: "Obsługiwany format logo to 'JPEG' lub 'PNG', 24x24px",
						rounded: 'Zaokrąglony',
						square: 'Kwadratowy',
						right: 'Prawo',
						left: 'Lewo',
					},
					recaptcha: {
						recaptcha: 'reCAPTCHA',
						sitekey: 'Klucz strony',
						secret: 'Sekret klucza',
						threshold: 'Próg',
						showFlag: 'Pokaż flagę reCAPTCHA',
					},
					chat: {
						chat: 'Czat',
						openTimeout: 'Czas otwarcia',
						openTimeoutSec: 'Czas otwarcia (sek)',
					},
					appointment: {
						appointment: 'Wizyta',
						days: 'Dni',
						availableAgents: 'Dostępni agentzy',
						showEmailField: 'Pokaż pole email',
						showMessageField: 'Pokaż pole wiadomości',
						resultPageText: 'Tekst strony wyniku',
						headingText: 'Tekst nagłówka',
						subheadingText: 'Tekst podnagłówka',
						showDefaultHeading:
							'Pokaż domyślny nagłówek i podnagłówek na stronie wyniku',
					},
					alternativeChannels: {
						alternativeChannels: 'Kanały alternatywne',
						title: 'Kanały komunikacyjne',
						email: 'Email',
						whatsapp: 'WhatsApp',
						telegram: 'Telegram',
						messenger: 'Messenger',
					},
					call: {
						title: 'Połączenie online',
						url: 'Punkt końcowy WebSocket',
					},
				},
				customChat: {
					customChat: 'Czat niestandardowy',
					customChatGateway: 'Brama czatu niestandardowego',
					appSecretHint: 'Modyfikacja tego pola przerwie integrację',
					metadata: {
						appSecret: 'Sekret aplikacji',
						callback: 'Powrót',
					},
				},
				uri: 'URI',
				newChatGateway: 'Nowa brama czatu',
				metadata: {
					apiKey: 'Klucz API',
					baseUrl: 'Adres bazowy',
					allowOrigin: 'Dozwolone źródło',
					readTimeout: 'Czas odczytu (sek)',
					writeTimeout: 'Czas zapisu (sek)',
					handshakeTimeout: 'Czas ustanowienia połączenia (sek)',
					botName: 'Nazwa botka',
					telegramToken: 'Token API BOT Telegram',
				},
			},

			callflow: {
				callflow: 'Przepływ połączenia',
			},
		},

		ccenter: {
			ccenter: 'Centrum kontaktowe',

			agents: {
				agents: 'Agent | Agenci',
				supervisors: 'Nadzorca | Nadzorcy',
				admins: 'Administrator | Administracja',
				subordinates: 'Podwładny agent | Podwładni agentzy',
				allAgents: 'Wszystkie agentzy',
				chatCount: 'Liczba czatów',
				taskCount: 'Liczba zadań',
				progressiveCountValidator:
					'Wartość powinna być większa niż 1 lub pusta',
				extraChatCount: 'Dodatkowa liczba czatów',
				state: 'Status',
				isSupervisor: 'Nadzorca',
				stateTime: 'Czas statusu',
				statusType: 'Typ statusu',
				addSkill: 'Dodaj umiejętność',
				editSkill: 'Edytuj umiejętność',
				statusHistory: 'Historia statusu',
				historyState: 'Stan',
				payload: 'Przyczyna',
				addSubordinate: 'Dodaj podwładnego agenta',
				historyChannel: 'Kanał',
				historyFrom: 'Od',
				historyTo: 'Do',
				historyDuration: 'Długość',
				emptyPopup: 'Sprawdź zapytanie filtrów',
				status: {
					online: 'Online',
					offline: 'Offline',
					pause: 'Zawieszenie',
					breakOut: 'Przerwa',
				},
				wfm: 'WFM',
				workingConditions: 'Warunki pracy',
				pauseTemplate: 'Szablon zawieszenia',
				agentScreenControl: 'Sterowanie ekranem agenta',
				agentScreenControlHint:
					'Nie można wyłączyć, gdy ustawienie dla zespołu jest włączone',
			},

			auditors: {
				auditors: 'Audytor | Audytorzy',
			},

			teams: {
				teams: 'Zespół | Zespoły',
				allTeams: 'Wszystkie zespoły',
				strategy: 'Strategia',
				parameters: 'Parametry',
				maxNoAnswer: 'Maksymalna liczba nieodpowiedzi',
				callTimeout: 'Czas oczekiwania na połączenie',
				inviteChatTimeout: 'Czas oczekiwania na zaakceptowanie czatu',
				wrapUpTime: 'Czas zakończenia',
				noAnswerDelayTime: 'Opóźnienie po nieodpowiedzi',
				taskAcceptTimeout: 'Czas oczekiwania na zaakceptowanie zadania',
				strategies: {
					random: 'Losowy',
					fewestCalls: 'Agent z najmniejszą liczbą połączeń',
					leastTalkTime: 'Agent z najkrótszym czasem rozmowy',
					topDown: 'Od góry w dół',
					roundRobin: 'Rondo-Robin',
					roundRobinBucket: 'Kubeł Rondo-Robin',
					longestIdleAgent: 'Agent z najdłuższym czasem bezczynności',
					skillCapacity: 'Poziom umiejętności',
				},
				hooks: {
					eventTypes: {
						agentStatus: 'Status agenta zmienił się',
					},
				},
				flows: {
					addFlowSchema: 'Dodaj schemat przepływu',
					editFlowSchema: 'Edytuj schemat przepływu',
				},
				supervisors: {
					addSupervisor: 'Dodaj nadzorcę',
					editSupervisor: 'Edytuj nadzorcę',
				},
				agents: {
					addAgent: 'Dodaj agenta',
					editAgent: 'Edytuj agenta',
				},
			},

			members: {
				members: 'Członek | Członkowie',
				allMembers: 'Wszystkie członkowie',
				addMember: 'Dodaj członka',
				destination: 'Miejsce docelowe',
				communications: 'Komunikacja',
				display: 'Numer wyświetlany',
				dtmf: 'DTMF',
				priority: ({ linked }) => linked('objects.memberPriority'),
				attempts: 'Próby',
				emptyWorkspace: 'Nie znaleziono członków',
				resetMembers: {
					resetMembers: 'Resetuj członków',
					description: {
						question: 'Czy na pewno chcesz zresetować nieudane próby',
						all: ({ linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')} bez żadnych ograniczeń czasowych?`,
						filtered: ({ named, linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')} z okresu\n${named('dateFrom')} do ${named('dateTo')}\nz uwzględnieniem zastosowanych filtrów i wyników wyszukiwania?`,
						selected: ({ linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')}?`,
					},
					descriptionCount: 'Zostanie przetworzonych rekordów: {count}',
					emptyDescription:
						'Żadne nieudane próby nie pasują do bieżących filtrów. Nie ma nic do zresetowania.',
					reset: 'Resetuj',
					successResetCount: 'Pomyślnie zresetowano {count} członków',
				},
				exportMembers: {
					exportMembers: 'Eksportuj członków',
				},
				endCause: {
					abandoned: ({ linked }) => linked('objects.stopCause.abandoned'),
					timeout: ({ linked }) => linked('objects.stopCause.timeout'),
					cancel: ({ linked }) => linked('objects.stopCause.cancel'),
					success: ({ linked }) => linked('objects.stopCause.success'),
					failed: ({ linked }) => linked('objects.stopCause.failed'),
					missed: ({ linked }) => linked('objects.stopCause.missed'),
					expired: ({ linked }) => linked('objects.stopCause.expired'),
					canceledByTimeout: ({ linked }) =>
						linked('objects.stopCause.canceledByTimeout'),
				},
				csvMappingFields: {
					name: 'Nazwa',
					timezoneId: ({ linked }) => linked('date.timezone'),
					priority: ({ linked }) => linked('vocabulary.priority'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
					bucketId: 'Zasobnik',
					agentId: ({ linked }) => linked('objects.agent.agent'),
					variables: ({ linked }) => linked('vocabulary.variables'),
					destination: ({ linked }) => linked('vocabulary.destination'),
					commPriority: 'Priorytet typów komunikacji',
					code: 'Kod',
					description: ({ linked }) => linked('vocabulary.description'),
					dtmf: 'DTMF',
				},
			},

			globalStateConfirmation: {
				title: 'Zastosuj zmiany',
				message:
					'Zmiany zostaną zastosowane do {count} rekordów. Czy na pewno?',
			},

			queues: {
				queues: 'Kolejka | Kolejki',
				allQueues: 'Wszystkie kolejki',
				type: 'Typ',
				state: 'Stan',
				active: 'Aktywna',
				notActive: 'Nieaktywna',
				activeCalls: 'Aktywne połączenia',
				waiting: 'Czekające',
				ringtone: 'Dzwonek',
				priority: 'Priorytet',
				teams: 'Zespół | Zespoły',
				tags: 'Tagi',
				newQueue: 'Nowa kolejka',
				saveBeforeAddingRecords:
					'Wypełnij wymagane pola kolejki przed dodaniem rekordów',
				blacklist: 'Lista zatrzymana',
				resources: ({ linked }) => linked('objects.ccenter.res.res'),
				resourceGroups: ({ linked }) =>
					linked('objects.ccenter.resGroups.resGroups'),
				newQueueDescription: 'Opis nowej kolejki',
				outboundIVRQueue: 'Kolejka IVR wychodząca',
				outboundIVR: 'IVR wychodzący',
				outboundIVRQueueDescription:
					'IVR wychodzący umożliwia organizacjom automatyczne zaangażowanie klientów poprzez wiele kanałów, takich jak połączenia głosowe automatyczne, wiadomości SMS, e-maile lub posty w mediach społecznościowych przy użyciu personalizowanych powiadomień.',
				inboundQueue: 'Kolejka przychodząca',
				inboundQueueDescription:
					'Kolejka przychodząca to miejsce, gdzie połączeniowie są umieszczani na holu, w kolejce, gdy czekają na rozmowę z agentem na żywo.',
				offlineQueue: 'Kolejka offline',
				offlineQueueDescription:
					'Kolejka offline daje połączeniowi opcję przerwania czekania na holu, wprowadzenie swojego numeru telefonu i otrzymanie powiadomienia zwrotnego, gdy będzie jego kolej.',
				previewDialer: 'Podgląd dialera',
				previewDialerDescription:
					'Podgląd kontaktu przed automatycznym zadzwoleń.',
				progressiveDialer: 'Dialer progressive',
				progressiveDialerDescription:
					'Dialer progressive minimalizuje czas stracony między połączeniami, automatycznie zadzwoleń numeru z listy połączeń, gdy agent stanie się dostępny.',
				predictiveDialer: 'Dialer predykcyjny',
				predictiveDialerDescription:
					'Dialer predykcyjny jednocześnie dzwoni do wielu numerów. Gdy klient odpowie, agent jest połączony z nimi.',
				chatInboundQueue: 'Kolejka przychodząca czatu',
				chatInboundQueueDescription:
					'Tak samo jak kolejka przychodząca, ale z czatami',
				imChatQueue: 'Kolejka czatu IM',
				imChatQueueDescription:
					'Tak samo jak kolejka czatu, ale dla komunikatorów',
				inboundJobQueue: 'Kolejka zadań przychodzących',
				inboundJobQueueDescription: 'Kolejka zadań przychodzących',
				outboundJobQueue: 'Kolejka zadań wychodzących',
				outboundJobQueueDescription: 'Kolejka zadań wychodzących',
				strategy: 'Strategia',
				timezone: 'Strefa czasowa',
				callLimit: 'Limit połączeń',
				variables: 'Zmienne',
				members: 'Członek | Członkowie',
				params: 'Parametry',
				discardAbandonedAfter: 'Odrzuć porzucone po',
				maxIdleAgent: 'Czas oczekiwania agenta',
				maxIdleClient: 'Czas oczekiwania klienta',
				maxIdleDialog: 'Maksymalny czas oczekiwania',
				timeoutWithNoAgents: 'Czas oczekiwania bez agentów',
				timeBaseScore: 'Wynik bazowy czasu',
				endless: 'Nieskończony',
				stickyAgent: 'Agent przyklejony',
				stickyAgentSec: 'Agent przyklejony (sek)',
				autoAnswerTone: 'Ostrzeżenie o automatycznym odpowiedzi',
				varKey: 'Klucz',
				varVal: 'Wartość',
				endCause: ({ linked }) => linked('objects.stopCause.stopCause'),
				offeringAt: 'Oferta w',
				destination: 'Miejsce docelowe | Miejsca docelowe',
				expire: 'Wygasa',
				originateTimeout: 'Czas początkowego połączenia',
				maxAgentLine: 'Maksymalna liczba linii agenta',
				maxAgentLose: 'Maksymalna liczba nieudanych połączeń agenta',
				minAttempts: 'Minimalna liczba prób predykcyjnych',
				maxAbandonedRate: 'Maksymalny odsetek porzuconych %',
				loadFactor: 'Współczynnik obciążenia',
				abandonRateAdjustment: 'Dostosowanie odsetka porzuconych',
				playbackSilence: 'Odtwórz ciszę',
				targetAbandonedRate: 'Docelowy odsetek porzuconych %',
				maxWaitTime: 'Maksymalny czas oczekiwania',
				maxWaitingSize: 'Maksymalna liczba oczekujących',
				waitBetweenRetries: 'Oczekiwanie między ponownymi próbami',
				waitBetweenRetriesDesc: 'Sortuj ponownie próby członków malejąco',
				strictCircuit: 'Obwód ścisły',
				retryAbandoned: 'Ponów porzucone',
				playbackFile: 'Plik odtwarzany',
				timeout: 'Czas oczekiwania',
				maxNumberOfRetry: 'Maksymalna liczba ponownych prób',
				minDuration: 'Minimalna długość udanego połączenia',
				maxAttempts: 'Maksymalna liczba prób',
				minOnlineAgents:
					'Dostęp do zawieszenia, gdy jest więcej online agentów niż',
				waitForResultStatus: 'Czekaj na status wyniku',
				bucketPriority: 'Priorytet',
				amd: 'AMD',
				enabled: 'Użyj AMD',
				ai: 'Sztuczna inteligencja',
				positiveLabels: 'Etykiety pozytywne',
				aiPlayback: 'Plik odtwarzany',
				allowNotSure: 'Przekaż NOTSURE do agenta',
				silenceNotSure: 'Przekaż ciszę do agenta',
				allowGreetingAgent: 'Zezwól na powitanie agenta',
				preSchema: 'Schemat przedwykonawczy',
				afterSchema: 'Schemat po wykonawczy',
				maxCalls: 'Maksymalna liczba zadań',
				dialingRate: 'Szybkość dialingu',
				maxCallsHint: 'Jeśli wartość wynosi 0, nie są wykonywane zadania',
				recordings: 'Nagrywanie',
				recordAll: 'Rozpocznij nagrywanie po odpowiedzi',
				perNumbers: 'Próby dialingu dla każdego numeru telefonu',
				maxWordLength: 'Maksymalna długość słowa (ms)',
				maxNumberOfWords: 'Maksymalna liczba słów',
				betweenWordsSilence: 'Cisza między słowami (ms)',
				minWordLength: 'Minimalna długość słowa (ms)',
				totalAnalysisTime: 'Łączny czas analizy (ms)',
				silenceThreshold: 'Próg ciszy (ms)',
				afterGreetingSilence: 'Cisza po powitaniu (ms)',
				greeting: 'Powitanie (ms)',
				initialSilence: 'Cisza początkowa (ms)',
				statisticTime: 'Interwał ponownego obliczania',
				communications: 'Typ komunikacji',
				manualDistribution: 'Rozdział ręczny',
				lastMessageTimeout: 'Czas oczekiwania od ostatniej wiadomości',
				stickyIgnoreStatus: 'Ignoruj status agenta',
				ignoreCalendar: 'Ignoruj kalendarz',
				resourceStrategy: {
					resourceStrategy: 'Strategia zasobów',
					priorityBased: 'Priorytetowa',
					evenDistribution: 'Równomierne rozdzielenie',
				},
				attemptsReset: {
					resetActiveAttempts: ({ linked }) =>
						linked('objects.permissions.roles.permissions.resetActiveAttempts'),
					title: 'Reset prób',
					attemptType: 'Typ próby',
					idleTime: 'Czas bezczynności (min)',
					result: ({ linked }) =>
						linked('objects.integrations.triggers.logs.result'),
					calls: 'Połączenia',
					attemptsCount: 'Próby',
				},
				processing: {
					processing: 'Przetwarzanie',
					enabled: 'Czekaj na wynik połączenia',
					formSchema: 'Schemat dynamicznego przetwarzania',
					sec: 'Czas przetwarzania pośredniego (sek)',
					renewalSec:
						'Zaproponuj przedłużenie przetwarzania końcowego, gdy pozostało (sek)',
					allowProlongation: 'Zezwalaj na przedłużenie przetwarzania końcowego',
					autosave: 'Zezwalaj na automatyczny zapis przetwarzania końcowego',
					repeatsNumber: 'Liczba powtórzeń',
					prolongationTimeSec: 'Czas przedłużenia (sek)',
					isTimeoutRetry: 'Ponawiaj do przekroczenia czasu',
				},
				queueStrategy: {
					fifo: 'FIFO (First In First Out)',
					lifo: 'LIFO (Last In First Out)',
					strict_fifo: 'Ścisłe FIFO (First In First Out)',
				},
				logs: {
					logs: 'Log | Logi',
					destination: 'Miejsce docelowe',
					offeringAt: 'Oferta',
					joinedAt: 'Początek',
					leavingAt: 'Koniec',
					duration: ({ linked }) => linked('vocabulary.duration'),
					viewNumber: 'Numer widoku',
					result: ({ linked }) => linked('objects.callReportingResult.result'),
					attempts: 'Próba',
					resultName: {
						abandoned: ({ linked }) =>
							linked('objects.callReportingResult.abandoned'),
						cancel: ({ linked }) =>
							linked('objects.callReportingResult.cancel'),
						success: ({ linked }) =>
							linked('objects.callReportingResult.success'),
						failed: ({ linked }) =>
							linked('objects.callReportingResult.failed'),
						missed: ({ linked }) =>
							linked('objects.callReportingResult.missed'),
						timeout: ({ linked }) =>
							linked('objects.callReportingResult.timeout'),
						endless: ({ linked }) =>
							linked('objects.callReportingResult.endless'),
						transferred: ({ linked }) =>
							linked('objects.callReportingResult.transferred'),
						shutdown: ({ linked }) =>
							linked('objects.callReportingResult.shutdown'),
					},
				},
				hooks: {
					hooks: 'Hook | Hooki',
					event: 'Zdarzenie',
					eventTypes: {
						joined: 'Dołączenie',
						answered: 'Odpowiedziane',
						offering: 'Oferta',
						bridged: 'Połączone',
						missed: 'Przegapione',
						leaving: 'Odejście',
						processing: 'Przetwarzanie',
						active: 'Aktywne',
					},
				},
				skills: {
					editSkill: 'Edytuj umiejętność',
					addSkill: 'Dodaj umiejętność',
				},
				buckets: {
					addBucket: 'Dodaj kubeł',
					editBucket: 'Edytuj kubeł',
				},
			},

			res: {
				res: 'Zasób | Zasoby',
				allRes: 'Wszystkie zasoby',
				reserve: 'Rezerwuj',
				searchPlaceholder: 'nazwa, brama..',
				cps: 'CPS',
				limit: 'Limit',
				cidType: 'Typ CID',
				ignoreEarlyMedia: 'Ignoruj wczesne media',
				numbers: 'Numer | Numery',
				displayNumbers: 'Numery wyświetlane',
				failure: 'Niepowodzenie',
				maxErrors: 'Maksymalna liczba niepowodzeń',
				errorCodes: 'Kody niepowodzeń żądania',
				patterns: 'Wzorzec numeru docelowego',
				priority: 'Priorytet',
				reserveResource: 'Rezerwuj zasób',
				failureDialDelay: 'Opóźnienie dialingu przy niepowodzeniu',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
				},
			},

			resGroups: {
				resGroups: 'Grupa zasobów | Grupy zasobów',
				allResGroups: 'Wszystkie grupy zasobów',
				searchPlaceholder: 'nazwa grupy zasobów..',
				addResGroup: 'Dodaj grupę zasobów',
				editResGroup: 'Edytuj grupę zasobów',
				strategy: 'Strategia',
				timerange: 'Zakres czasu',
				timerangeFrom: 'Od',
				timerangeTo: 'Do',
			},
		},

		integrations: {
			integrations: 'Integracje',
			emptyWorkspace: 'Jeszcze nie ma profili',

			storage: {
				storage: 'Pamięć',
				allStorages: 'Wszystkie pamięci',
				type: 'Typ',
				maxSize: 'Przestrzeń pamięci (GB)',
				expireDays: 'Żywotność (dni)',
				priority: 'Priorytet',
				newStorage: 'Nowa pamięć',
				newStorageDescription: 'Opis nowej pamięci',
				local: 'Lokalna',
				s3: 'Plik S3',
				digitalOcean: 'Digital Ocean Spaces',
				backblaze: 'Backblaze B2',
				dropbox: 'Dropbox',
				drive: 'Google Drive',
				configuration: 'Konfiguracja',
				pathPattern: 'Wzorzec ścieżki',
				localFolder: 'Lokalna folder',
				s3Key: 'Klucz ID',
				s3Access: 'Klucz dostępu',
				bucket: 'Kubeł',
				region: 'Region',
				oceanKey: 'Klucz ID',
				oceanAccess: 'Klucz dostępu',
				backblazeAccount: 'ID konta',
				backblazeKey: 'Klucz aplikacji',
				backblazeBucketId: 'ID kubeła',
				dropboxKey: 'Token dostępu',
				driveFolder: 'Nazwa folderu',
				driveEmail: 'Email Google',
				driveKey: 'Klucz prywatny',
				s3Endpoint: 'Punkt końcowy',
			},

			storagePolicies: {
				storagePolicies: 'Polityka pamięci | Polityki pamięci',
				mimeTypes: 'Typy MIME',
				retentionDays: 'Dni przechowywania',
				maxDownloadSpeed: 'Maksymalna prędkość pobierania (kbps)',
				maxUploadSpeed: 'Maksymalna prędkość wgrywania (kbps)',
				maxUploadSize: 'Maksymalny rozmiar wgrywania (bajty)',
				applyToFiles: 'Zastosuj dni przechowywania do istniejących plików',
				applyPopupMessage:
					'Nowy czas przechowywania zostanie zastosowany do istniejących plików zgodnie z polityką. Czy chcesz kontynuować?',
				channels: {
					[StorageUploadFileChannel.CallChannel]: 'połączenie',
					[StorageUploadFileChannel.ChatChannel]: 'czat',
					[StorageUploadFileChannel.MediaChannel]: 'media',
					[StorageUploadFileChannel.MailChannel]: 'email',
					[StorageUploadFileChannel.LogChannel]: 'log',
					[StorageUploadFileChannel.ScreenRecordingChannel]: 'nagrania ekranu',
				},
				encryptFile: 'Szyfruj nowe pliki',
				encryptFileHint:
					'Nie będzie można odszyfrować plików, jeśli klucz szyfrowania zostanie utracony! Zapisy są dostępne tylko przez API lub interfejs.',
				encryptionAlertTitle: 'Alert szyfrowania',
				encryptionEnableMessage: 'Tylko nowe pliki będą szyfrowane.',
				encryptionDisableMessage:
					'Stare pliki pozostaną zaszyfrowane.\nNowe pliki nie będą szyfrowane.',
			},

			cognitiveProfiles: {
				cognitiveProfiles: 'Profil cognitive | Profile cognitive',
				properties: {
					region: 'Region',
					locale: 'Język',
				},
			},
			emailProfiles: {
				emailProfiles: 'Profil email | Profile email',
				mailbox: 'Skrzynka pocztowa',
				smtpPort: 'Port SMTP',
				imapPort: 'Port IMAP',
				smtpHost: 'Host SMTP',
				imapHost: 'Host IMAP',
				fetchInterval: 'Interwał odświeżania',
				listen: 'Słuchaj',
				authType: 'Typ uwierzytelniania',
				authenticatedAs: 'Uwierzytelniony jako',
			},
			singleSignOn: {
				singleSignOn: 'Profil SSO | Profile SSO',
				provider: 'Dostawca',
				clientId: 'Application (client) ID',
				clientSecret: 'Client secret',
				discoveryUrl: 'Discovery URL',
				scopes: 'Zakresy',
				scopesPlaceholder: 'Wpisz zakres i naciśnij Enter',
				inspect: 'Inspect',
				inspectHint: 'Wyślij żądanie do dostawcy i odbierz token',
				token: 'Token',
				showToken: 'Pokaż token',
				inspectDescription: 'Wyślij żądanie do dostawcy i odbierz token',
				mapping: 'Mapowanie',
				mappingKeyHint:
					'Podaj atrybut użytkownika (np. email, username, extension) jako klucz wyszukiwania.',
			},

			importCsv: {
				importCsv: 'Importuj CSV z pliku | Importy CSV z pliku',
				allImportsCsv: 'Wszystkie dane importowane z plików CSV',
				source: 'Miejsce docelowe importu',
				settings: 'Ustawienia',
				mappings: 'Mapowanie pól',
				mappingsHint:
					'W tej sekcji powinieneś podać nazwy kolumn plików CSV w poniższych polach w zgodzie z ich etykietami',
				columnHeader: '{name} kolumna',
				members: {
					clearMembers: 'Wyczyść istniejących członków',
				},
			},

			tokens: {
				tokens: 'Token | Tokeny',
				allTokens: 'Wszystkie tokeny',
				expires: 'Wygasa',
				popupMessage:
					'Pobierz teraz plik klucza lub skopiuj go. Jeśli nie pobierzesz pliku klucza teraz, nie będziesz mógł go ponownie odzyskać. Aby zapewnić bezpieczeństwo, przechowuj swój klucz tokenowy w bezpieczny sposób i nie go udostępniaj.',
				tokenCreated: 'Twój token został pomyślnie utworzony!',
			},

			triggers: {
				triggers: 'Wyzwalacz | Wyzwalacze',
				allTriggers: 'Wszystkie wyzwalacze',
				type: 'Typ',
				schema: 'Schemat',
				newTrigger: 'Nowy wyzwalacz',
				newTriggerDescription:
					'Wybierz szablon, aby rozpocząć, lub zacznij od pustego kartezjańskiego, aby rozpocząć od nowa',
				event: 'Na zdarzenie',
				onEventDescription: 'Scheduler JSON Schema oparty na zdarzeniach',
				cron: 'W czasie',
				atTimeDescription: 'Scheduler JSON Schema oparty na czasie',
				eventSelect: ({ linked }) =>
					linked('objects.ccenter.queues.hooks.event'),
				cases: 'Przypadki',
				caseFiles: 'Pliki przypadków',
				caseComments: 'Komentarze do przypadków',
				caseLinks: 'Linki do przypadków',
				call: 'Połączenie',
				relatedCases: 'Powiązane przypadki',
				expression: 'Wyrażenie',
				timeout: 'Czas oczekiwania',
				resolutionTime: ({ linked }) => linked('cases.resolutionTime'),
				logs: {
					logs: 'Historia uruchomienia',
					startedAt: 'Początek',
					result: 'Wynik',
				},
				recordCall: 'Nagraj połączenie',
				runTrigger: 'Uruchom wyzwalacz',
			},
		},
		system: {
			system: 'System',
			changelogs: {
				changelogs: 'Dziennik zmian | Dzienniki zmian',
				objects: 'Obiekt | Obiekty',
				daysToStore: 'Dni przechowywania',
				storage: 'Pobierz do',
				logs: {
					logs: 'Log | Logi',
					actions: 'Operacja | Operacje',
					records: 'ID rekordu | ID rekordów',
					actionType: {
						[LoggerAction.Create]: 'Utwórz',
						[LoggerAction.Delete]: 'Usuń',
						[LoggerAction.Update]: 'Edytuj',
					},
				},
				period: {
					period: 'Okres',
					options: {
						daily: 'Dzienny',
						weekly: 'Tygodniowy',
						fortnightly: 'Dwutygodniowy',
						monthly: 'Miesięczny',
					},
				},
			},
			configuration: {
				configuration: 'Konfiguracja | Konfiguracje',
				parameter: 'Parametr',
			},
			globalVariables: {
				globalVariables: 'Zmienna globalna | Zmienne globalne',
				encrypted: 'Zaszyfrowane',
				valueInfo: 'Wprowadź wartość tylko wtedy, gdy chcesz ją edytować',
				newTitle: 'Nowa zmienna globalna',
				editTitle: 'Edytuj zmienną globalną',
			},
		},

		pagination: {
			rowsPerPage: 'Wiersze na stronę',
		},
	},

	filters: {
		team: 'Zespół',
		queueType: 'Typ kolejki',
	},

	webitelUI: {
		filters: {
			tags: ({ linked }) => linked('vocabulary.tag'),
			joinedAt: ({ linked }) => linked('objects.joinedAt'),
			result: ({ linked }) => linked('objects.callReportingResult.result'),
			duration: ({ linked }) => linked('vocabulary.duration'),
		},
	},

	utils: {
		downloadFilesBtn: {
			downloadFiles: 'Pobierz pliki',
			filesLoaded: 'Pliki załadowane',
			zippingProgress: 'Postęp kompresji',
		},
	},

	errorPages: {
		goToHome: 'Przejdź do strony głównej',
		page403: {
			title: 'Odmowa dostępu',
			text: 'Przepraszamy, nie masz wystarczających uprawnień do przeglądania tej strony.',
		},
		page404: {
			title: 'Wygląda na to, że się zgubisz',
			text: 'Przepraszamy, nie możemy znaleźć strony, której szukasz.',
		},
	},

	icon: {
		docs: 'Dokumentacja',
		logout: 'Wyloguj',
		account: 'Konto',
		appNavigator: 'Nawigator aplikacji',
		settings: 'Ustawienia',
	},

	iconHints: {
		upload: 'Wgrywaj',
		reload: 'Odśwież tabelę',
		edit: 'Edytuj',
		delete: 'Usuń',
		deleteAll: 'Usuń wszystkie elementy',
		deleteSelected: 'Usuń {count} wybranych elementów',
		deleteFiltered: 'Usuń wszystkie filtrowane elementy',
		resetAll: 'Zresetuj wszystkich członków',
		resetSelected:
			'Zresetuj {count} wybranego członka | Zresetuj {count} wybranych członków',
		resetFiltered: 'Zresetuj wszystkich filtrowanych członków',
		generate: 'Generuj',
		add: 'Dodaj',
		history: 'Historia',
		download: 'Pobierz',
		downloadAll: 'Pobierz wszystkie',
		draggable: 'Przeciągalny',
		play: 'Odtwórz',
		pause: 'Wstrzymaj',
		resume: 'Wznów',
		close: 'Zamknij',
		change: 'Zmień',
		volume: 'Głośność',
		stop: 'Zatrzymaj',
		members: 'Członkowie',
		moveUp: 'Przenieś w górę',
		moveDown: 'Przenieś w dół',
		nextPage: 'Następna strona',
		prevPage: 'Poprzednia strona',
		expand: 'Rozwiń',
		collapse: 'Zwiń',
	},
	errors: {
		invalidJson: 'JSON jest nieprawidłowy',
	},
	reusable: {
		time: {
			t15m: '15 min',
			t30m: '30 min',
			t45m: '45 min',
			t1h: '1 godzina',
			t3h: '4 godziny',
			t6h: '6 godzin',
		},
	},
};
